<template>
    <v-container>
        <v-layout column>
            <h2>Aktiviteter</h2>
            <v-data-table :headers="headers" :items="activities" hide-actions disable-initial-sort>
                <template slot="items" slot-scope="props">
                    <tr>
                        <td>
                            <v-icon v-if="!!props.item.phone">phone_in_talk</v-icon>
                            <v-icon v-else>local_shipping</v-icon>
                        </td>
                        <td>{{props.item.accessCode_id}}</td>
                        <td>{{codeType(props.item.action)}}</td>
                        <td>{{props.item.gate_id}}</td>
                        <td>{{props.item.gate_name}}</td>
                        <td>{{props.item.user_id}}</td>
                        <td>{{props.item.username}}</td>
                        <td>{{props.item.phone}}</td>
                        <td>{{props.item.code}}</td>
                        <td :class="[props.item.zonecolor]" style="border-radius: 5px;">{{props.item.zonename}}</td>
                        <td>{{moment.unix(props.item.created_at).local().format("YYYY.MM.DD @HH:mm")}}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-layout>
    </v-container>
</template>

<script>
// import moment from "moment";
// import axios from "axios";
export default {
    data() {
        return {
            activities: [],
            headers: [
                { text: "origin" },
                { text: "accessCode_id", value: "accessCode_id" },
                { text: "action", value: "action" },
                { text: "gate_id", value: "gate_id" },
                { text: "gate_name", value: "gate_name" },
                { text: "user_id", value: "user_id" },
                { text: "username", value: "username" },
                { text: "phone", value: "phone" },
                { text: "code", value: "code" },
                { text: "zone", value: "zone" },
                { text: "created_at", value: "created_at" }
            ]
        };
    },
    methods: {
        codeType: function(type) {
            switch (type.toLowerCase()) {
                case "entry":
                    return "inngang";
                case "exit":
                    return "utgang";
                default:
                    return "ukjent";
            }
        }
    },
    mounted() {
        this.axios
            .get("/activity", {
                params: {
                    unit: "week"
                }
            })
            .then(response => {
                response.data.data.forEach(activity => {
                    let color = activity.zonecolor;

                    if(!color)
                        return;

                    if(!color.includes('lighten')){
                        color += ' lighten-2';
                    }

                    activity.zonecolor = color;
                });
                this.activities = response.data.data;
            });
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="scss" scoped>
</style>
